import './VNInfoIcon.scss';

import { InfoOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import type { MouseEventHandler, ReactNode } from 'react';
import React from 'react';

export type VNInfoIconProps = {
  /** Shown in the hover tooltip. */
  description: ReactNode;
  /** When set, e.g. open a details modal while the tooltip explains on hover. */
  onClick?: MouseEventHandler<SVGSVGElement>;
  placement?: 'top' | 'bottom' | 'left' | 'right';
};

const VNInfoIcon = ({ description, onClick, placement = 'top' }: VNInfoIconProps) => (
  <div className={onClick ? 'vn-info-icon vn-info-icon--clickable' : 'vn-info-icon'}>
    <Tooltip title={description} placement={placement} arrow>
      <div className="info-icon">
        <InfoOutlined onClick={onClick} />
      </div>
    </Tooltip>
  </div>
);

export default VNInfoIcon;
